import Pusher from 'pusher-js';
import create from 'zustand';
import useAuth from '@/hooks/stores/useAuth';
import { REVERB_APP_KEY, REVERB_HOST, REVERB_PORT, API_URL, REVERB_TLS } from '@/config';
import api from '@/lib/axios';

const getReverbApiUrl = () => {
    if (REVERB_HOST) {
        let api_url = REVERB_HOST.startsWith('https://') ? REVERB_HOST : `https://${REVERB_HOST}`;
        api_url = api_url.endsWith('/') ? api_url.slice(0, -1) : api_url;
        return api_url.endsWith('/api') ? api_url : `${api_url}/api`;
    }
    return API_URL;
};

// Pusher.logToConsole = import.meta.env.DEV;

const authorizer = (channel) => {
    return {
        authorize: (socketId, callback) => {
            // const { userID } = useAuth.getState();
            // api.post(`${getReverbApiUrl()}/broadcasting/auth`, {
            api.post(`${API_URL}/broadcasting/auth`, {
                socket_id: socketId,
                channel_name: channel.name,
                // user_id: userID
            })
            .then(response => {
                callback(false, response.data);
            })
            .catch(error => {
                callback(true, error);
            });
        }
    };
};

const createPusher = () => {
    const pusher = new Pusher(REVERB_APP_KEY, {
        cluster: 'mt1',
        wsHost: REVERB_HOST,
        wsPort: REVERB_PORT,
        wssPort: REVERB_PORT,
        forceTLS: REVERB_TLS === 'true',
        enabledTransports: ['ws', 'wss'],
        encrypted: true,
        authorizer: authorizer,
    });

    return pusher;
};

const usePusherStore = create((set, get) => ({
    pusher: null,
    init: () => {
        if (get().pusher) return get().pusher;
        const p = createPusher();
        // optional test subscription kept for parity with previous behavior
        try {
            const channel = p.subscribe('test-channel');
            channel.bind('.test.message', (data) => {
                console.log('received test message', data);
            });
            set({ pusher: p, channel });
        } catch {
            set({ pusher: p });
        }
        return p;
    },
    disconnect: () => {
        const p = get().pusher;
        if (p) p.disconnect();
        set({ pusher: null, channel: null });
    },
    reconnect: () => {
        const p = get().pusher;
        if (p) {
            p.disconnect();
            p.connect();
            return p;
        }
        return get().init();
    }
}));

const getInstance = () => {
    return usePusherStore.getState().pusher || usePusherStore.getState().init();
};

export const updatePusherAuth = () => {
    // kept for compatibility; authentication handled inside authorizer
};

export const disconnectPusher = () => {
    return usePusherStore.getState().disconnect();
};

export const reconnectPusher = () => {
    return usePusherStore.getState().reconnect();
};

const pusherProxy = new Proxy({}, {
    get(_, prop) {
        const inst = getInstance();
        const value = inst[prop];
        if (typeof value === 'function') return value.bind(inst);
        return value;
    }
});

export default pusherProxy;
